import { createBrowserRouter, RouterProvider } from 'react-router';
import { createApi } from './auth/api';
import { appRoutes, routerPage } from './routes';

// Every page reads the signed-in user from GET /api/me; signed out, it goes to Sign in. After a
// deploy, a move to another page loads the new build; the router tells which page it shows.
const made: { router?: ReturnType<typeof createBrowserRouter> } = {};
const router = createBrowserRouter(
  appRoutes({ api: createApi(), here: () => (made.router ? routerPage(made.router) : null) }),
);
made.router = router;

export function App() {
  return (
    <div className="ss">
      <RouterProvider router={router} />
    </div>
  );
}
